import ItemPersonDTO, { IItemPerson } from "../planningTool/DTO/ItemPersonDTO"
import { Getter, Setter } from "../services/ComService"

export enum GLItemKind {
    generic   = 0,
    marketing = 1,
    coaching  = 2,
}
export const GLItemKinds = [
    {
        id: GLItemKind.generic,
        name: 'Allgemein',
        access: [],
    },
    {
        id: GLItemKind.marketing,
        name: 'Vertrieb',
        access: [],
    },
    {
        id: GLItemKind.coaching,
        name: 'Coaching',
        access: ['author'],
    }
]
export enum GLItemStatus {
    generic = 0,
    marketingContacted = 1,
    marketingOrderDiscussed = 2,
    marketingOrderSend = 3,
    marketingWaitingForFeedback = 4,
    marketingOrderWon = 5,
    marketingOrderLost = 6,
    marketingInactive = 7,
    marketingDone = 8,
    marketingPotential = 9,
    marketingCampaign = 10,
    marketingCurrentPotential = 11,
    marketingInfoLoop = 12,

}
export const GLItemStatuses = {
    [GLItemKind.generic]: [],
    [GLItemKind.marketing]: [
        {
            status: GLItemStatus.generic,
            name: 'Anfrage',
        },
        {
            status: GLItemStatus.marketingContacted,
            name: 'Kontaktiert',
        },
        {
            status: GLItemStatus.marketingOrderDiscussed,
            name: 'Auftrag geklärt',
        },
        {
            status: GLItemStatus.marketingOrderSend,
            name: 'Angebot verschickt',
        },
        {
            status: GLItemStatus.marketingWaitingForFeedback,
            name: 'Entscheidungsprozess',
        },
        {
            status: GLItemStatus.marketingOrderWon,
            name: 'Gewonnen',
        },
        {
            status: GLItemStatus.marketingOrderLost,
            name: 'Verloren',
        },
        {
            status: GLItemStatus.marketingInactive,
            name: 'Inaktiv',
        },
        {
            status: GLItemStatus.marketingPotential,
            name: 'Neukundenpotenzial',
        },
        {
            status: GLItemStatus.marketingCurrentPotential,
            name: 'Bestandskundenpotenzial',
        },
        {
            status: GLItemStatus.marketingInfoLoop,
            name: 'Infoloop',
        },
        {
            status: GLItemStatus.marketingCampaign,
            name: 'Kampagne',
        },
        {
            status: undefined,
            name: 'Alle',
        },
    ],
    [GLItemKind.coaching]: [
        
    ],
}
interface IAuthor {
    id: number,
    name: string,
    me: boolean,
}

export interface IGLItem {
    id: number
    parentId?: number
    children?: IGLItem[]
    childrenCount?: number
    kind: GLItemKind
    status: GLItemStatus
    created?: string
    updated?: string | Date
    donedate?: string | Date
    startdate?: string | Date
    enddate?: string | Date
    repeatinterval?: number
    content?: string
    headline?: string
    personId?: number
    userId?: number
    person?: IItemPerson
    author?: IAuthor
    revenue_potential?: number
    revenue_probability?: number
    weighted_revenue?: number
    manualdate?: string | Date
}

export class GLItemDTO {
    id: number = -1
    childrenCount: number = -1
    parentId?: number
    children?: GLItemDTO[]
    kind: GLItemKind = GLItemKind.generic
    status: GLItemStatus = GLItemStatus.generic
    created?: string
    updated?: string | Date
    donedate?: string | Date
    startdate?: string | Date | null
    enddate?: string | Date | null
    repeatinterval?: number
    content: string = ''
    headline: string = ''
    personId?: number
    userId?: number
    person?: ItemPersonDTO
    author?: IAuthor
    revenue_potential?: number
    revenue_probability?: number
    weighted_revenue?: number
    manualdate?: string | Date

    constructor(data: IGLItem) {
        this.init(data)
    }

    private init(data: IGLItem) {
        this.id = data.id
        this.parentId = data.parentId
        this.children = data.children ? data.children.map(c => new GLItemDTO(c)) : undefined
        this.childrenCount = data.childrenCount || -1
        this.kind = data.kind
        this.status = data.status
        this.created = data.created
        this.updated = data.updated
        this.donedate = data.donedate
        this.startdate = data.startdate
        this.enddate = data.enddate
        this.repeatinterval = data.repeatinterval
        this.content = data.content || ''
        this.headline = data.headline || ''
        this.personId = data.personId
        this.userId = data.userId
        this.person = data.person ? new ItemPersonDTO(data.person) : undefined
        this.author = data.author
        this.revenue_potential = data.revenue_potential
        this.revenue_probability = data.revenue_probability
        this.weighted_revenue = data.weighted_revenue
        this.manualdate = data.manualdate
    }

    public get() {
        return {
            id: this.id !== -1 ? this.id : undefined,
            parentId: this.parentId,
            kind: this.kind,
            status: this.status,
            created: this.created,
            updated: this.updated,
            donedate: this.donedate,
            startdate: this.startdate,
            enddate: this.enddate,
            repeatinterval: this.repeatinterval,
            content: this.content,
            headline: this.headline,
            personId: this.personId,
            userId: this.userId,
            revenue_potential: this.revenue_potential,
            revenue_probability: this.revenue_probability,
            weighted_revenue: this.weighted_revenue,
            manualdate: this.manualdate,
        }
    }

    public async save(force?: boolean) {
        if (this.id === -1 && !force) { return } // Do not save, if we change template
        const METHOD = this.id > -1 ? 'PATCH' : 'POST'
        this.init(await Setter('spt/g_l_items' + (this.id > -1 ? `/${this.id}` : '') + '.json', this.get(), {method: METHOD}))
    }

    public async getFromServer() {
        const data = await Getter(`spt/g_l_items/${this.id}`)
        this.init(data)
    }

    public showDelete() {
        return !!this.author?.me
    }

    public async delete(): Promise<boolean> {
        // Quit, if author not me:
        if (!this.showDelete()) { return false }
        if (!window.confirm('Eintrag wirklich löschen?')) {
            return false
        }
        if(this.id > -1) {
            await Setter(`spt/g_l_items/${this.id}`, {}, {method: 'DELETE'})
            return true
        }
        return false
    }

    public showKindOption(kind: GLItemKind) {
        console.log('showKindOption', kind, this)
        if (this.id === -1) { return true }
        const access = GLItemKinds.find(k => k.id === kind)?.access || []
        if (access.length === 0) { return true }
        if (access.includes('author') && this.author?.me) { return true }
        return false
    }

    public calculateWeightedRevenue() {
        if (this.revenue_potential && this.revenue_probability) {
            this.weighted_revenue = this.revenue_potential * this.revenue_probability * 0.01
        }
    }

    public async setRevenuePotential(revenue_potential: number) {
        this.revenue_potential = revenue_potential
        this.calculateWeightedRevenue()
        await this.save()
    }

    public async setRevenueProbability(revenue_probability: number) {
        this.revenue_probability = revenue_probability
        this.calculateWeightedRevenue()
        await this.save()
    }

    public async setQuarter(q: string, year: number) {
        let startDate: Date | null
        let endDate: Date | null
        switch (q) {
            case 'Q1':
                startDate = new Date(`${year}-01-01`)
                endDate = new Date(`${year}-03-31`)
                break
            case 'Q2':
                startDate = new Date(`${year}-04-01`)
                endDate = new Date(`${year}-06-30`)
                break
            case 'Q3':
                startDate = new Date(`${year}-07-01`)
                endDate = new Date(`${year}-09-30`)
                break
            case 'Q4':
                startDate = new Date(`${year}-10-01`)
                endDate = new Date(`${year}-12-31`)
                break
            case 'none':
                startDate = null
                endDate = null
                break
            default:
                startDate = null
                endDate = null
                break
        }
        this.startdate = startDate
        this.enddate = endDate
        await this.save()
    }

    public getQuarters() {
        return [
            {
                id: 'Q1',
                name: 'Q1'
            },
            {
                id: 'Q2',
                name: 'Q2'
            },
            {
                id: 'Q3',
                name: 'Q3'
            },
            {
                id: 'Q4',
                name: 'Q4'
            }
        ]
    }

    public getQuarter() {
        if (!this.startdate) {
            const now = new Date()
            const currentYear = now.getFullYear()
            return {quarter: 'none', year: currentYear}
        }
        const workDate = new Date(this.startdate)
        const year = workDate.getFullYear()
        const month = workDate.getMonth() + 1
        console.log('getQuarter', year, month)
        if (month < 4) {
            return {quarter: 'Q1', year}
        } else if (month < 7) {
            return {quarter: 'Q2', year}
        } else if (month < 10) {
            return {quarter: 'Q3', year}
        } else {
            return {quarter: 'Q4', year}
        }
    }

    public async clearQuarter() {
        if (window.confirm('Quartal wirklich löschen?')) {
            this.startdate = null
            this.enddate = null
            await this.save()
        }
    }

    public getAuthorInitials() {
        if (!this.author?.name) { return '' }
        const name = this.author.name.trim()
        const parts = name.split('@')
        if (parts.length === 0) {
            return '?'
        }
        const names = parts[0].split('.')
        if (names.length > 1) {
            return names.map(n => n[0].toUpperCase()).join('')
        }
        return names[0]
    }
}
